import { useLayoutEffect, useRef, useState } from "react"
import Tooltip from "../components/tooltip"
import React from "react"

export function OverflowTipText({text}){
    var ref=useRef(null)
    var [isCropped,set_isCropped]=useState(false)
    useLayoutEffect(()=>{
      if (isTextTruncated(ref.current)) {
        set_isCropped(true)
      } else {
        set_isCropped(false)
      }
    })
    function isTextTruncated(element) {
      return element.scrollWidth > element.clientWidth;
    }
    return <Tooltip tip={isCropped ? text : ''}><div ref={ref} css={`overflow:hidden;text-overflow:ellipsis;`}>{text}</div></Tooltip>
  }
